import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HubBlockQueryCommand, HubCalendarActionCommand } from '../../../commands/pagination.query.command';
import { ButtonTriggerEvent } from '../../../common/components';
import { BaseComponent } from '../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubPlace } from '../../../models/hub/hub.place';
import { AlertifyService } from '../../../services/alertify.service';
import { HubApiService } from '../../../services/hub.api.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BlockKeywordCommand, RevertCommand } from '../../../commands/accounts/block.keyword.command';
import { ImageService } from '../../../services/image.service';
import { HubComponent } from '../hub.component';
import { ModalService } from '../../../common/services/modal.service';
import { constantConfigs } from '../../../common/constants/constant';
import { HubBlockedOrganizer } from '../../../models/hub/hub.blocked.organizer';
import { EventTimeService } from '../../../services/event.time.service';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { TokenInfo } from '../../../models/auth/token.info';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'ig-block-keywords',
  templateUrl: './block.keywords.component.html',
  styleUrls: ['./block.keywords.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlockKeywordsComponent extends BaseComponent implements OnInit {
  public blacklist = [];
  public blockedEventDomains = [];
  public blockPlaces: HubPlace[] = [];
  public blockByGlobalKeywordsPlaces: HubPlace[] = [];
  public blockByClientKeywordsPlaces: HubPlace[] = [];
  public clientPlaceBlockKeywords: string[] = [];
  public blockEvents: HubEvent[] = [];
  public blockOrganizers: HubBlockedOrganizer[] = [];
  public hubName: string;
  public facebookHost: string;
  public keywordText: string;
  public blackType = 'keyword';
  public blockKeywordsFormGroup: FormGroup;
  public command: BlockKeywordCommand;
  public blockPlacesCommand: HubBlockQueryCommand;
  public blockEventsCommand: HubBlockQueryCommand;
  public blackSourceItems = [
    {
      text: 'keyword',
      value: 'keyword',
      selected: true,
    },
    {
      text: 'organizer / venue',
      value: 'user',
    },
  ];

  constructor(
    private hubApiService: HubApiService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private parent: HubComponent,
    private imageService: ImageService,
    private alertify: AlertifyService,
    private modalService: ModalService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    this.facebookHost = constantConfigs.facebook.host;
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.blockKeywordsFormGroup = this.formBuilder.group({
      blackValue: [null, [Validators.required]],
    });
    this.blockPlacesCommand = new HubBlockQueryCommand();
    this.blockEventsCommand = new HubBlockQueryCommand();
    this.getBlacklist();
    this.getBlockPlaces();
    this.getBlockEvents();
    this.getBlockOrganizers();
    this.getBlockedEventDomains();
    this.getGlobalBlockedByKeywordsPlaceList();
    this.getClientPlaceBlockKeywords();
    this.getClientPlaceBlockKeywordsPlaceList();
  }

  public typeSourceChange(target) {
    this.blackType = target.value;
  }

  public blockPlaceKeywords(event: ButtonTriggerEvent) {
    this.hubApiService
      .addClientPlaceBlockKeyword(this.hubName, this.clientPlaceBlockKeywords)
      .finally(event.complete)
      .subscribe((data) => {
        this.alertify.successfully('Set blocked keywords for places');
      });
  }

  public revertBlockOrganizer(organizer: HubBlockedOrganizer) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .unBlockOrganizer(this.hubName, organizer)
          .finally(event.complete)
          .subscribe(() => {
            this.getBlockOrganizers();
            this.getBlockEvents();
          });
      },
    };
    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to revert this organizer?',
      confirmModalConfirmButtonText: 'Revert',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public revertBlockEvent(eventItem: HubEvent) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .unBlock(this.hubName, eventItem._id)
          .finally(event.complete)
          .subscribe(() => {
            this.getBlockPlaces();
            this.getBlockEvents();
            this.getBlockOrganizers();
          });
      },
    };
    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      // confirmModalDescription: 'Are you sure you want to revert this item, and all events of this organizer will be reverted too?',
      confirmModalDescription: 'Are you sure you want to revert this event?',
      confirmModalConfirmButtonText: 'Revert',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public revertBlockPlace(placeItem: HubPlace) {
    let actions = <ConfirmModalActions>{
      confirm: (place: ButtonTriggerEvent) => {
        this.hubApiService
          .unBlockPlace(this.hubName, placeItem._id)
          .finally(place.complete)
          .subscribe(() => {
            this.getBlockPlaces();
            this.getBlockEvents();
          });
      },
    };
    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to revert this item?',
      confirmModalConfirmButtonText: 'Revert',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public deleteBlockKeyword(blackItem) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.command = new BlockKeywordCommand(blackItem.blackValue, blackItem.blackType);
        this.hubApiService
          .deleteBlockKeyword(this.hubName, this.command)
          .finally(event.complete)
          .subscribe(() => {
            this.getBlacklist();
          });
      },
    };
    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this item?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public addBlockKeyword(event: ButtonTriggerEvent) {
    this.command = new BlockKeywordCommand(this.keywordText, this.blackType);
    this.hubApiService
      .addBlockKeyword(this.hubName, this.command)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Add keyword');
        this.keywordText = null;
        this.getBlacklist();
      });
  }

  public getBlacklist() {
    this.hubApiService.getBlockKeywords(this.hubName).subscribe((data) => {
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          if (a.blackType < b.blackType) return -1;
          if (a.blackType > b.blackType) return 1;
          if (a.blackValue < b.blackValue) return -1;
          if (a.blackValue > b.blackValue) return 1;
          return 0;
        });
      }
      this.blacklist = data;
    });
  }
  public getGlobalBlockedByKeywordsPlaceList() {
    this.hubApiService.getGlobalBlockedByKeywordsPlaces(this.hubName).subscribe((data) => {
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          const aTitle = a.title || a.name;
          const bTitle = b.title || b.name;
          if (aTitle < bTitle) return -1;
          if (aTitle > bTitle) return 1;
          return 0;
        });
      }
      this.blockByGlobalKeywordsPlaces = data;
    });
  }
  public getClientPlaceBlockKeywordsPlaceList() {
    this.hubApiService.getClientPlaceBlockKeywordsPlaceList(this.hubName).subscribe((data) => {
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      }
      this.blockByClientKeywordsPlaces = data;
    });
  }
  public getClientPlaceBlockKeywords() {
    this.hubApiService.getClientPlaceBlockKeywords(this.hubName).subscribe((data) => {
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
      }
      this.clientPlaceBlockKeywords = data;
    });
  }
  public getBlockedEventDomains() {
    this.hubApiService.getBlockedEventDomains(this.hubName).subscribe((data) => {
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
      }
      this.blockedEventDomains = data;
    });
  }
  public updateBlockedEventDomains(event: ButtonTriggerEvent) {
    this.hubApiService
      .updateBlockedEventDomains(this.hubName, this.blockedEventDomains)
      .takeUntil(this.isDestroyed)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Set blocked event domain');
      });
  }

  public getBlockOrganizers() {
    this.hubApiService.getBlockedOrganizers(this.hubName).subscribe((data) => {
      this.blockOrganizers = data;
    });
  }

  public getBlockEvents() {
    this.hubApiService.getBlockEvents(this.hubName, this.blockEventsCommand).subscribe((data) => {
      data.forEach((item) => {
        item = EventTimeService.processEventTime(item);
      });
      if (data && data.length > 0) {
        data = data.sort((a, b) => {
          if (a.startTime < b.startTime) return -1;
          if (a.startTime > b.startTime) return 1;
          return 0;
        });
      }
      this.blockEvents = data;
    });
  }

  public getBlockPlaces() {
    this.hubApiService.getBlockPlaces(this.hubName, this.blockPlacesCommand.queryParams).subscribe((data) => {
      this.blockPlaces = data;

      if (this.blockPlaces && this.blockPlaces.length > 0) {
        this.blockPlaces = this.blockPlaces.sort((a, b) => {
          const aTitle = a.title || a.name;
          const bTitle = b.title || b.name;
          if (aTitle < bTitle) return -1;
          if (aTitle > bTitle) return 1;
          return 0;
        });
      }
    });
  }

  public deleteEventPermanently(eventItem: HubEvent) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteEvent(this.hubName, eventItem._id)
          .finally(event.complete)
          .subscribe(() => {
            this.getBlockPlaces();
            this.getBlockEvents();
            this.getBlockOrganizers();
          });
      },
      cancel: () => {},
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to remove this event permanently, this operation cannot be reverted. ${
        eventItem.isManuallyCreated ? '' : 'But this event will be added again in the next deliveries.'
      }`,
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public deletePlacePermanently(placeItem: HubPlace) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .deletePlace(this.hubName, placeItem._id)
          .finally(event.complete)
          .subscribe(() => {
            this.getBlockPlaces();
            this.getBlockEvents();
          });
      },
      cancel: () => {},
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to remove this place permanently, this operation cannot be reverted. ${
        placeItem.isManuallyCreated ? '' : 'But this place will be added again in the next deliveries.'
      }`,
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public tabChanged($event) {    
    if (!window.location.href.includes('localhost')) {
      const authToken = localStorage.getItem(localStorageKeys.authToken);
      let tokenInfo = jwt_decode<TokenInfo>(authToken);
      try {  
        let trackName = "click - ContentManagement - BlockKeywords - " + $event.tab.textLabel;
        window['pendo'].track(trackName,{                    
          accountId: tokenInfo.userName,
          timestamp: Date.now(),
          hubName: this.hubName          
        });    
      } catch (error) {
        console.error(error);
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/block.keywords/block.keywords.component.ts